import {Pipe, PipeTransform, signal, Signal} from '@angular/core';

@Pipe({
	name: 'resizeBase64',
	standalone: true,
})
export class ResizeBase64Pipe implements PipeTransform {
	transform(base64Src: string, maxWidth: number = 100, maxHeight: number = 100): Signal<string> {
		const resizedBase64$ = signal('');
		if (!base64Src) {
			resizedBase64$.set('');
			return resizedBase64$;
		}

		const img = new Image();

		img.onload = () => {
			const canvas = document.createElement('canvas');
			let width = img.width;
			let height = img.height;

			// Calculate the new dimensions
			if (width > height) {
				if (width > maxWidth) {
					height = Math.round(height * (maxWidth / width));
					width = maxWidth;
				}
			} else {
				if (height > maxHeight) {
					width = Math.round(width * (maxHeight / height));
					height = maxHeight;
				}
			}

			canvas.width = width;
			canvas.height = height;

			const ctx = canvas.getContext('2d');
			ctx?.drawImage(img, 0, 0, width, height);

			// Convert the resized image back to base64
			const resizedBase64 = canvas.toDataURL('image/jpeg');
			resizedBase64$.set(resizedBase64);
		};

		img.src = base64Src;
		return resizedBase64$;
	}
}
